/**
 * ============================================================
 * KEJJA OS — Timezones (curated IANA subset)
 * ============================================================
 * ~80 most-used zones. Group by region for display.
 * ============================================================
 */

export interface TimezoneDef {
  iana: string;
  label: string;
  region: string;
}

export const TIMEZONES: TimezoneDef[] = [
  // Africa
  { iana: 'Africa/Nairobi',        label: 'Nairobi (EAT, UTC+3)',        region: 'Africa' },
  { iana: 'Africa/Kampala',        label: 'Kampala (EAT, UTC+3)',        region: 'Africa' },
  { iana: 'Africa/Dar_es_Salaam',  label: 'Dar es Salaam (EAT, UTC+3)',  region: 'Africa' },
  { iana: 'Africa/Kigali',         label: 'Kigali (CAT, UTC+2)',         region: 'Africa' },
  { iana: 'Africa/Bujumbura',      label: 'Bujumbura (CAT, UTC+2)',      region: 'Africa' },
  { iana: 'Africa/Addis_Ababa',    label: 'Addis Ababa (EAT, UTC+3)',    region: 'Africa' },
  { iana: 'Africa/Mogadishu',      label: 'Mogadishu (EAT, UTC+3)',      region: 'Africa' },
  { iana: 'Africa/Juba',           label: 'Juba (CAT, UTC+2)',           region: 'Africa' },
  { iana: 'Africa/Khartoum',       label: 'Khartoum (CAT, UTC+2)',       region: 'Africa' },
  { iana: 'Africa/Lagos',          label: 'Lagos (WAT, UTC+1)',          region: 'Africa' },
  { iana: 'Africa/Accra',          label: 'Accra (GMT, UTC+0)',          region: 'Africa' },
  { iana: 'Africa/Dakar',          label: 'Dakar (GMT, UTC+0)',          region: 'Africa' },
  { iana: 'Africa/Abidjan',        label: 'Abidjan (GMT, UTC+0)',        region: 'Africa' },
  { iana: 'Africa/Douala',         label: 'Douala (WAT, UTC+1)',         region: 'Africa' },
  { iana: 'Africa/Johannesburg',   label: 'Johannesburg (SAST, UTC+2)',  region: 'Africa' },
  { iana: 'Africa/Harare',         label: 'Harare (CAT, UTC+2)',         region: 'Africa' },
  { iana: 'Africa/Lusaka',         label: 'Lusaka (CAT, UTC+2)',         region: 'Africa' },
  { iana: 'Africa/Gaborone',       label: 'Gaborone (CAT, UTC+2)',       region: 'Africa' },
  { iana: 'Africa/Windhoek',       label: 'Windhoek (CAT, UTC+2)',       region: 'Africa' },
  { iana: 'Africa/Maputo',         label: 'Maputo (CAT, UTC+2)',         region: 'Africa' },
  { iana: 'Africa/Blantyre',       label: 'Blantyre (CAT, UTC+2)',       region: 'Africa' },
  { iana: 'Africa/Luanda',         label: 'Luanda (WAT, UTC+1)',         region: 'Africa' },
  { iana: 'Africa/Cairo',          label: 'Cairo (EET, UTC+2)',          region: 'Africa' },
  { iana: 'Africa/Casablanca',     label: 'Casablanca (WET, UTC+1)',     region: 'Africa' },
  { iana: 'Africa/Algiers',        label: 'Algiers (CET, UTC+1)',        region: 'Africa' },
  { iana: 'Africa/Tunis',          label: 'Tunis (CET, UTC+1)',          region: 'Africa' },
  { iana: 'Africa/Tripoli',        label: 'Tripoli (EET, UTC+2)',        region: 'Africa' },

  // Europe
  { iana: 'Europe/London',      label: 'London (GMT/BST)',     region: 'Europe' },
  { iana: 'Europe/Dublin',      label: 'Dublin (GMT/IST)',     region: 'Europe' },
  { iana: 'Europe/Paris',       label: 'Paris (CET/CEST)',     region: 'Europe' },
  { iana: 'Europe/Berlin',      label: 'Berlin (CET/CEST)',    region: 'Europe' },
  { iana: 'Europe/Rome',        label: 'Rome (CET/CEST)',      region: 'Europe' },
  { iana: 'Europe/Madrid',      label: 'Madrid (CET/CEST)',    region: 'Europe' },
  { iana: 'Europe/Lisbon',      label: 'Lisbon (WET/WEST)',    region: 'Europe' },
  { iana: 'Europe/Amsterdam',   label: 'Amsterdam (CET/CEST)', region: 'Europe' },
  { iana: 'Europe/Brussels',    label: 'Brussels (CET/CEST)',  region: 'Europe' },
  { iana: 'Europe/Zurich',      label: 'Zurich (CET/CEST)',    region: 'Europe' },
  { iana: 'Europe/Stockholm',   label: 'Stockholm (CET/CEST)', region: 'Europe' },
  { iana: 'Europe/Oslo',        label: 'Oslo (CET/CEST)',      region: 'Europe' },
  { iana: 'Europe/Copenhagen',  label: 'Copenhagen (CET/CEST)',region: 'Europe' },
  { iana: 'Europe/Helsinki',    label: 'Helsinki (EET/EEST)',  region: 'Europe' },
  { iana: 'Europe/Warsaw',      label: 'Warsaw (CET/CEST)',    region: 'Europe' },
  { iana: 'Europe/Moscow',      label: 'Moscow (MSK, UTC+3)',  region: 'Europe' },

  // Americas
  { iana: 'America/New_York',       label: 'New York (ET)',           region: 'Americas' },
  { iana: 'America/Chicago',        label: 'Chicago (CT)',            region: 'Americas' },
  { iana: 'America/Denver',         label: 'Denver (MT)',             region: 'Americas' },
  { iana: 'America/Los_Angeles',    label: 'Los Angeles (PT)',        region: 'Americas' },
  { iana: 'America/Toronto',        label: 'Toronto (ET)',            region: 'Americas' },
  { iana: 'America/Vancouver',      label: 'Vancouver (PT)',          region: 'Americas' },
  { iana: 'America/Mexico_City',    label: 'Mexico City (CST)',       region: 'Americas' },
  { iana: 'America/Sao_Paulo',      label: 'São Paulo (BRT, UTC-3)',  region: 'Americas' },
  { iana: 'America/Argentina/Buenos_Aires', label: 'Buenos Aires (ART, UTC-3)', region: 'Americas' },

  // Middle East
  { iana: 'Asia/Dubai',       label: 'Dubai (GST, UTC+4)',    region: 'Middle East' },
  { iana: 'Asia/Riyadh',      label: 'Riyadh (AST, UTC+3)',   region: 'Middle East' },
  { iana: 'Asia/Jerusalem',   label: 'Jerusalem (IST/IDT)',   region: 'Middle East' },

  // Asia
  { iana: 'Asia/Kolkata',     label: 'Kolkata/Mumbai (IST)',  region: 'Asia' },
  { iana: 'Asia/Shanghai',    label: 'Shanghai (CST, UTC+8)', region: 'Asia' },
  { iana: 'Asia/Hong_Kong',   label: 'Hong Kong (HKT)',       region: 'Asia' },
  { iana: 'Asia/Singapore',   label: 'Singapore (SGT)',       region: 'Asia' },
  { iana: 'Asia/Tokyo',       label: 'Tokyo (JST)',           region: 'Asia' },
  { iana: 'Asia/Seoul',       label: 'Seoul (KST)',           region: 'Asia' },
  { iana: 'Asia/Bangkok',     label: 'Bangkok (ICT)',         region: 'Asia' },

  // Oceania
  { iana: 'Australia/Sydney',    label: 'Sydney (AEST/AEDT)',    region: 'Oceania' },
  { iana: 'Australia/Melbourne', label: 'Melbourne (AEST/AEDT)', region: 'Oceania' },
  { iana: 'Australia/Perth',     label: 'Perth (AWST)',          region: 'Oceania' },
  { iana: 'Pacific/Auckland',    label: 'Auckland (NZST/NZDT)',  region: 'Oceania' },

  // UTC fallback
  { iana: 'UTC', label: 'UTC (Coordinated Universal Time)', region: 'Other' },
];

export function timezonesByRegion(): Record<string, TimezoneDef[]> {
  return TIMEZONES.reduce((acc, tz) => {
    if (!acc[tz.region]) acc[tz.region] = [];
    acc[tz.region].push(tz);
    return acc;
  }, {} as Record<string, TimezoneDef[]>);
}
